import { render, staticRenderFns } from "./ACenter.vue?vue&type=template&id=633acff8"
import script from "./ACenter.vue?vue&type=script&lang=js"
export * from "./ACenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports